import React from 'react';
type EventWordmarkProps = {
  name: string;
  className?: string;
};

// Sweeping calligraphic wordmark for Superluxury's private event series
export function EventWordmark({
  name,
  className = ''
}: EventWordmarkProps) {
  return <span translate="no" className={`relative inline-block ${className}`} data-id="element-421" data-mp="5msaj9m47zr8">
      {/* Long brushed underline swash, extending past the word on both sides */}
      <svg viewBox="0 0 1000 80" preserveAspectRatio="none" className="pointer-events-none absolute -left-[14%] -right-[10%] bottom-[14%] h-[0.32em] w-[124%]" aria-hidden="true" data-id="element-422" data-mp="feo7ghcgtjtv">
        <path d="M0 74 C 260 40, 640 22, 1000 6 C 640 30, 300 54, 0 78 Z" fill="currentColor" data-id="element-423" data-mp="pddrafnx9ecr" />
      </svg>
      <span className="relative block whitespace-nowrap font-script leading-[0.9]" style={{
      WebkitTextStroke: '0.01em currentColor'
    }} data-id="element-424" data-mp="tcml1kiypc8b">
        {name}
      </span>
    </span>;
}